export const getAddinsActionControl = "xWd";
export const sensitivityActionControl = "yWd";
export const sensitivityLearnMoreActionControl = "zWd";
export const showLinkDialogActionControl = "AWd";
export const attachFileActionControl = "BWd";
export const attachSignatureActionControl = "CWd";
export const highImportanceActionControl = "DWd";
export const clpLabelDropDownLearnMoreActionControl = "EWd";
export const clpLabelDropDownLearnMoreToolTipTextActionControl = "FWd";
export const findTimeDescription = "GWd";
export const proofingOptionsDescription = "HWd";
export default {getAddinsActionControl,sensitivityActionControl,sensitivityLearnMoreActionControl,showLinkDialogActionControl,attachFileActionControl,attachSignatureActionControl,highImportanceActionControl,clpLabelDropDownLearnMoreActionControl,clpLabelDropDownLearnMoreToolTipTextActionControl,findTimeDescription,proofingOptionsDescription};